import script from "./ReportsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsMenu.vue?vue&type=script&setup=true&lang=js"

import "./ReportsMenu.vue?vue&type=style&index=0&id=8facfd12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8facfd12"]])

export default __exports__